// import React, { useEffect, useState } from "react";
// import SearchIcon from "@mui/icons-material/Search";
// import { useNavigate } from "react-router-dom";
// import PaginationComponent from "../../Components/PaginationComponent";
// import purchaseService from "../../Services/purchaseService";
// import toast from "react-hot-toast";
// import MedicineDetailsModal from "../Medicines/MedicineDetailsModal";
// import moment from "moment/moment";
// import distributorServices from "../../Services/distributorServices";

// const DiscountModal = ({ open, onClose, onApprove, purchaseId }) => {
//   const [discount, setDiscount] = useState("");

//   const handleDiscountChange = (e) => {
//     setDiscount(e.target.value);
//   };

//   const handleSubmit = () => {
//     if (isNaN(discount) || parseFloat(discount) < 0) {
//       toast.error("Invalid discount amount.");
//       return;
//     }
//     onApprove(purchaseId, parseFloat(discount));
//     onClose();
//   };

//   return (
//     <div
//       className={`fixed inset-0 flex items-center justify-center bg-gray-600 bg-opacity-50 ${
//         !open ? "hidden" : ""
//       }`}
//     >
//       <div className="bg-white p-6 rounded-lg w-[300px]">
//         <h2 className="text-xl font-semibold mb-4">Enter Discount</h2>
//         <input
//           type="number"
//           placeholder="Discount Amount"
//           value={discount}
//           onChange={handleDiscountChange}
//           className="w-full p-2 border border-gray-300 rounded-md mb-4"
//         />
//         <div className="flex justify-between">
//           <button
//             onClick={onClose}
//             className="bg-gray-300 px-4 py-2 rounded-md"
//           >
//             Cancel
//           </button>
//           <button
//             onClick={handleSubmit}
//             className="bg-green-500 text-white px-4 py-2 rounded-md"
//           >
//             Approve
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const DistributorList = () => {
//   const [searchData, setSearchData] = useState("");
//   const [filteredData, setFilteredData] = useState([]);
//   const [paginatedData, setPaginatedData] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [purchases, setPurchases] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false); // for MedicineDetailsModal
//   const [selectedMedicine, setSelectedMedicine] = useState(null);
//   const [discountModalOpen, setDiscountModalOpen] = useState(false); // for Discount Modal
//   const [selectedPurchaseId, setSelectedPurchaseId] = useState(null); // Track selected purchase for discount

//   const itemsPerPage = 10;

//   useEffect(() => {
//     fetchPurchases();
//   }, []);
//   const fetchPurchases = async () => {
//     try {
//       setLoading(true);
//       const response = await distributorServices.fetchAll();
//       setPurchases(response.distributors);
//       setLoading(false);
//     } catch (error) {
//       setLoading(false);
//       toast.error("Error fetching purchases");
//     }
//   };

//   useEffect(() => {
//     const filteredResult =
//       purchases?.filter((item) =>
//         item?.name?.toLowerCase().includes(searchData.toLowerCase())
//       ) || [];
//     setFilteredData(filteredResult);
//     setCurrentPage(1);
//   }, [searchData, purchases]);

//   useEffect(() => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
//   }, [currentPage, filteredData]);

//   const handleOpenModal = (medicine) => {
//     setSelectedMedicine(medicine);
//     setModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setSelectedMedicine(null);
//     setModalOpen(false);
//   };

//   const handleOpenDiscountModal = (purchaseId) => {
//     setSelectedPurchaseId(purchaseId);
//     setDiscountModalOpen(true);
//   };

//   const handleCloseDiscountModal = () => {
//     setDiscountModalOpen(false);
//     setSelectedPurchaseId(null);
//   };

//   const handleApprovePurchase = async (purchaseId, discount) => {
//     try {
//       await purchaseService.approvePurchase(purchaseId, discount);
//       toast.success("Purchase approved successfully!");
//       fetchPurchases();
//     } catch (error) {
//       toast.error("Error approving purchase.");
//     }
//   };

//   const navigate = useNavigate();

//   return (
//     <div>
//       <div className="p-4">
//         <h1 className="ml-[3%] text-[19px] text-gray-700 font-[700]">
//           Distributors
//         </h1>
//         <h1 className="ml-[3%] text-[13px] text-gray-700 mb-4">
//           {filteredData?.length || 0} records found
//         </h1>

//         <div className="mx-[3%]">
//           <table className="w-[100%] rounded-xl overflow-hidden">
//             <thead>
//               <tr className="bg-gray-700 text-white text-xs text-left capitalize leading-normal">
//                 <th className="py-4 w-[10%] pl-4">
//                   Purchase Id
//                 </th>
//                 <th className="py-4 w-[20%] pl-4">
//                   Supplier Name
//                 </th>
//                 <th className="py-4 w-[20%] pl-4">
//                   Company Name
//                 </th>
//                 {/* <th className="py-4 w-[10%] text-center">
//                   Amount
//                 </th> */}
//                 <th className="py-4 w-[10%] text-center">
//                   Purchase Date
//                 </th>
//                 {/* <th className="py-4 w-[10%] text-center">
//                   Actions
//                 </th>
//                 <th className="py-[1%] w-[10%] text-[.8rem] text-gray-700 text-center">
//                   Status
//                 </th> */}
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData?.map((purchase, index) => (
//                 <tr
//                   key={purchase?.id}
//                   className="bg-white text-xs text-left border-t-[1px] border-gray-200"
//                 >
//                   <td className="w-[10%] py-4 pl-4 font-bold">
//                       {index + 1 + (currentPage - 1) * itemsPerPage}.
//                   </td>
//                   <td className="w-[20%] pl-4 font-bold">
//                       {purchase?.name}
//                   </td>
//                   <td className="w-[20%] font-bold pl-4">
//                       {purchase?.company}
//                   </td>
//                   {/* <td className="w-[10%] text-center">
//                       {purchase?.amount}
//                   </td> */}
//                   <td className="w-[10%] text-center">
//                     {moment(purchase?.date).format("ll")}
//                   </td>
//                   {/* <td className="w-[10%] text-center">
//                     <button
//                       className=" font-[500] text-blue-500 mr-2"
//                       onClick={() =>
//                         navigate(`purchaseview?id=${purchase?.id}`)
//                       }
//                     >
//                       View
//                     </button>
//                   </td>
//                   <td className="py-[2%] w-[10%] text-center">
//                     <div
//                       className={`text-[13px] font-[500] ${
//                         purchase?.approved === 0
//                           ? "text-red-500"
//                           : "text-green-500"
//                       }`}
//                       // onClick={() => handleOpenDiscountModal(purchase?.id)}
//                     >
//                       {purchase?.approved === 0 ? "Not Approved" : "Approved"}
//                     </div>
//                   </td> */}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         <PaginationComponent
//           filteredData={filteredData}
//           setPaginatedData={setPaginatedData}
//           itemsPerPage={itemsPerPage}
//           currentPage={currentPage}
//           setCurrentPage={setCurrentPage}
//         />
//       </div>

//       <MedicineDetailsModal
//         open={modalOpen}
//         onClose={handleCloseModal}
//         medicine={selectedMedicine}
//       />

//       <DiscountModal
//         open={discountModalOpen}
//         onClose={handleCloseDiscountModal}
//         onApprove={handleApprovePurchase}
//         purchaseId={selectedPurchaseId}
//       />
//     </div>
//   );
// };

// export default DistributorList;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import distributorServices from "../../Services/distributorServices";
import moment from "moment";

const DistributorList = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPurchases();
  }, []);

  const fetchPurchases = async () => {
    try {
      setLoading(true);
      const response = await distributorServices.fetchAll();
      setPurchases(response.distributors);
    } catch (error) {
      toast.error("Error fetching distributors");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const result =
      purchases?.filter((item) =>
        item?.name?.toLowerCase().includes(searchData.toLowerCase()),
      ) || [];
    setFilteredData(result);
  }, [searchData, purchases]);

  const colWidths = ["70px", "180px", "180px", "130px"];
  const ColGroup = () => (
    <colgroup>
      {colWidths.map((w, i) => (
        <col key={i} style={{ width: w, minWidth: w }} />
      ))}
    </colgroup>
  );

  return (
    <div className="p-3 sm:p-4 font-sans">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
            Distributors
          </p>
          <p className="text-xs text-gray-400 mt-0.5">
            {filteredData.length || 0} records found
          </p>
        </div>
      </div>

      <div className="relative mb-4">
        <svg
          className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
          />
        </svg>
        <input
          type="search"
          placeholder="Search by supplier name..."
          value={searchData}
          onChange={(e) => setSearchData(e.target.value)}
          className="w-full sm:w-72 pl-9 pr-4 py-3 text-xs border border-gray-200 rounded-lg bg-white text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-blue-100"
        />
      </div>

      {/* ══ MOBILE CARDS ══ */}
      <div className="block sm:hidden space-y-2">
        {loading ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            Loading...
          </div>
        ) : filteredData.length === 0 ? (
          <div className="text-center py-10 text-gray-400 text-xs">
            No distributors found
          </div>
        ) : (
          filteredData.map((purchase, index) => (
            <div
              key={purchase?.id}
              className="border border-gray-200 rounded-xl bg-white px-3 py-3"
            >
              <div className="flex items-center gap-2 mb-2">
                {/* <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-[11px] font-semibold text-gray-600 uppercase flex-shrink-0">
                  {purchase?.name?.charAt(0) || "D"}
                </div> */}
                <div>
                  <p className="text-[12px] font-semibold text-gray-800">
                    {purchase?.name}
                  </p>
                  <p className="text-[10px] text-gray-400">
                    {purchase?.company}
                  </p>
                </div>
              </div>
              <div className="divide-y divide-gray-100">
                <div className="flex justify-between py-1.5">
                  <span className="text-[11px] text-gray-400 w-20">Date</span>
                  <span className="text-[11px] text-gray-700">
                    {moment(purchase?.date).format("ll")}
                  </span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* ══ DESKTOP TABLE ══ */}
      <div className="hidden sm:block border rounded-xl overflow-hidden">
        <div className="overflow-y-auto" style={{ maxHeight: "520px" }}>
          <table
            className="w-full text-sm"
            style={{
              tableLayout: "fixed",
              borderCollapse: "separate",
              borderSpacing: 0,
            }}
          >
            <ColGroup />
            <thead>
              <tr>
                {[
                  "Sr No.",
                  "Supplier Name",
                  "Company Name",
                  "Purchase Date",
                ].map((label, i) => (
                  <th
                    key={label}
                    className={`sticky top-0 z-20 bg-[#215187] text-left px-4 py-2.5 text-[11px] text-gray-100 uppercase font-medium ${i < 3 ? "border-r border-white/10" : ""}`}
                  >
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td
                    colSpan={4}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    Loading...
                  </td>
                </tr>
              ) : filteredData.length === 0 ? (
                <tr>
                  <td
                    colSpan={4}
                    className="text-center py-10 text-gray-400 text-[12px]"
                  >
                    No distributors found
                  </td>
                </tr>
              ) : (
                filteredData.map((purchase, index) => (
                  <tr
                    key={purchase?.id}
                    className={`border-b border-gray-100 hover:bg-green-50 transition-colors ${index % 2 ? "bg-gray-50" : "bg-white"}`}
                  >
                    <td className="px-4 py-2.5 text-[12px] font-semibold text-gray-500 border-r border-gray-100">
                      {index + 1}
                    </td>
                    <td className="px-4 py-2.5 border-r border-gray-100">
                      <div className="flex items-center gap-2">
                        {/* <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center text-[10px] font-semibold text-gray-600 uppercase flex-shrink-0">
                          {purchase?.name?.charAt(0) || "D"}
                        </div> */}
                        <span className="text-[12px] font-medium text-gray-800 truncate">
                          {purchase?.name}
                        </span>
                      </div>
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600 border-r border-gray-100 truncate">
                      {purchase?.company}
                    </td>
                    <td className="px-4 py-2.5 text-[12px] text-gray-600">
                      {moment(purchase?.date).format("ll")}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
            <tfoot>
              <tr>
                <td
                  colSpan={4}
                  className="sticky bottom-0 z-20 bg-[#215187] px-4 py-2.5 text-[12px] font-medium text-gray-100 border-t border-white/10"
                >
                  {filteredData.length || 0} total records
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DistributorList;
